import { createSelector } from '@ngrx/store';
import { denormalize } from 'normalizr';
import {
  ByKey,
  createListStateIdsSelector,
  createListStateParamsSelector,
  createStateErrorsSelector,
  createStateLoadingSelector,
  createStateSuccessSelector,
  IdType,
  ListState
} from '@industi/ngx-common';
import { Dictionary } from '../../../../shared/models/dictionary';
import { EntityTypes } from '../../../entity/entity-types';
import { getDictionaryBrandListState } from '../brand.reducer';
import { createEntitiesSelector } from '../../../entity/entities.reducer';
import { createSymfonyTotalCountSelector } from '../../../symfony/list/selectors/list.selectors';
import { Entities } from '../../../entity/entities';
import { EntityState } from '../../../entity/entity.reducer';

const createState = (id: IdType) => createSelector(
  getDictionaryBrandListState,
  (state: ByKey<ListState>) => state && state[id]
);

const createStateByContext = (id: IdType) => createListStateIdsSelector(createState(id));

export const createDictionaryBrandListData = (id: IdType) => createSelector(
  createStateByContext(id),
  createEntitiesSelector([
    EntityTypes.brand,
    EntityTypes.image
  ]),
  (
    ids: IdType[],
    entities: EntityState
  ) => denormalize(ids, [Entities[EntityTypes.brand]], entities) as Dictionary[]
);

export const createDictionaryBrandListLoading = (id: IdType) => createStateLoadingSelector(
  createState(id));

export const createDictionaryBrandListSuccess = (id: IdType) => createStateSuccessSelector(
  createState(id));

export const createDictionaryBrandListErrors = (id: IdType) => createStateErrorsSelector(
  createState(id));

export const createDictionaryBrandListTotalCount = (id: IdType) => createSymfonyTotalCountSelector(
  createState(id));

export const createDictionaryBrandListParams = (id: IdType) => createListStateParamsSelector(
  createState(id));
